import { useEffect } from 'react';
import { isChunkLoadError, reloadOnce } from '@/app/chunk-reload';
import { de } from '@/i18n/de';
import { Button } from '@/shell/ui/button';
import { InternalLink } from '@/shell/ui/internal-link';

/** Kein Zugang: das Konto ist angemeldet, aber nicht freigeschaltet ([A] 5.10, V12-05). */
export function NoAccessPage() {
  return (
    <div className="grid justify-items-start gap-3">
      <h1 className="text-h1 font-bold text-ink">{de.states.noAccessTitle}</h1>
      <p className="max-w-[60ch] text-body text-ink">{de.states.noAccessText}</p>
      <a
        href="/api/v1/auth/login"
        className="rounded-control text-body font-semibold text-accent underline underline-offset-4"
      >
        {de.states.noAccessAction}
      </a>
    </div>
  );
}

/** Unbekannter Pfad. */
export function NotFoundPage() {
  return (
    <div className="grid justify-items-start gap-3">
      <h1 className="text-h1 font-bold text-ink">{de.states.notFoundTitle}</h1>
      <p className="max-w-[60ch] text-body text-ink">{de.states.notFoundText}</p>
      <InternalLink
        href="/"
        className="rounded-control text-body font-semibold text-accent underline underline-offset-4"
      >
        {de.states.toStart}
      </InternalLink>
    </div>
  );
}

/** Platzhalter für Seiten, die noch nicht gebaut sind (URL-Vertrag ist schon festgelegt). */
export function ComingSoonPage({ title }: { title: string }) {
  return (
    <div className="grid justify-items-start gap-3">
      <h1 className="text-h1 font-bold text-ink">{title}</h1>
      <p className="max-w-[60ch] text-body text-ink-muted">{de.states.comingSoon}</p>
    </div>
  );
}

/**
 * Fehler beim Anzeigen einer Seite (Standard-Fehlerkomponente des Routers). Ein Ladefehler des Seitenbündels
 * (neuer Stand nach einem Deploy) löst einmalig automatisch einen Reload aus; sonst bleibt der Knopf.
 */
export function RouteErrorPage({ error }: { error: unknown }) {
  useEffect(() => {
    if (isChunkLoadError(error)) {
      reloadOnce();
    }
  }, [error]);
  return (
    <div role="alert" className="grid justify-items-start gap-3">
      <h1 className="text-h1 font-bold text-ink">{de.states.routeErrorTitle}</h1>
      <p className="max-w-[60ch] text-body text-ink">{de.states.routeErrorText}</p>
      <Button variant="secondary" onClick={() => window.location.reload()}>
        {de.states.reloadPage}
      </Button>
    </div>
  );
}
